module.exports = __webpack_public_path__ + "img/right.d635cfd8.svg";